import { useEffect, useState } from 'react';
import { fetchBudgetUserProfile, fetchBudgetsList } from '../../../api/fetchBudget';
import { BudgetRecipientEnum } from '../createAndEdit/types';
import { IBudgetsListResponse } from '../../../api/fetchBudget';

interface IUseBudgetsListParams {
  occurrenceId: string;
  view: string;
}

export const useBudgetsList = (params: IUseBudgetsListParams) => {
  const { occurrenceId, view } = params;
  const [budgetsListResponse, setBudgetsListResponse] = useState<IBudgetsListResponse | null>(
    null,
  );
  const [userProfile, setUserProfile] = useState<BudgetRecipientEnum | undefined>(undefined);

  useEffect(() => {
    const loadUserProfile = async () => {
      const profile = await fetchBudgetUserProfile();
      setUserProfile(profile);
    };
    loadUserProfile();
  }, []);

  useEffect(() => {
    const loadBudgets = async () => {
      try {
        const response = await fetchBudgetsList(occurrenceId, 'number', 'desc', 1, 50);
        setBudgetsListResponse(response);
      } catch (error) {
        setBudgetsListResponse({
          budgets: [],
          totalElements: 0,
          totalPages: 0,
          currentPage: 1,
          pageSize: 50,
          last: true,
          first: true,
        });
      }
    };

    if (view === 'list') {
      loadBudgets();
    }
  }, [view, occurrenceId]);

  const loadBudgets = async (
    sortBy?: string,
    sortDirection?: 'asc' | 'desc',
    page?: number,
    pageSize?: number,
  ) => {
    const response = await fetchBudgetsList(occurrenceId, sortBy, sortDirection, page, pageSize);
    setBudgetsListResponse(response);
  };

  return {
    budgetsListResponse,
    userProfile,
    loadBudgets,
  };
};

